import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs/Observable';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  })
};


const baseUrl = "https://vindecoder.azurewebsites.net";
// const baseUrl = "http://localhost:8080";
@Injectable({
  providedIn: 'root'
})
export class VinService {
  constructor(
    private http: HttpClient, ) { }

  public decode(vinNumber): Observable<any> {
    return this.http.get(baseUrl + '/decode', {
      params: {
        vin: vinNumber
      },
    })
  }

  public readVin(imgDat): Observable<any> {
    var data = {
      'imgData': imgDat,
    }
    return this.http.post<any>(baseUrl + '/read', data, httpOptions);
  }
}
